(()=>{
'use strict';
const D=window.KINNIE,P=D.products;
const LEG=D.legal||{ship:'/policies/shipping-policy',ret:'/policies/refund-policy'};
const root=document.documentElement;
root.classList.add('js');
if(!('onpagereveal' in window))root.classList.add('no-vt');
const $=(s,r=document)=>r.querySelector(s),$$=(s,r=document)=>[...r.querySelectorAll(s)];
const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
const nf=new Intl.NumberFormat('nl-NL',{minimumFractionDigits:2,maximumFractionDigits:2});
const eur=n=>'€'+nf.format(n);
const rnd=(a,b)=>a+Math.random()*(b-a);
const pageEl=$('[data-page]'),page=pageEl?pageEl.dataset.page:'';

/* ---------- opslag (blijft bewaard tussen pagina's, met veilige terugval) ---------- */
const mem={};
const store={
  get(k,d){try{const v=localStorage.getItem(k);if(v!==null)return JSON.parse(v)}catch(e){}return k in mem?mem[k]:d},
  set(k,v){mem[k]=v;try{localStorage.setItem(k,JSON.stringify(v))}catch(e){}}
};
const skuById={};Object.entries(P).forEach(([k,p])=>{skuById[p.id]=k});
let shopCart={items:[],item_count:0,original_total_price:0,total_discount:0,total_price:0};
let cart={};
const isSold=sku=>!P[sku]||!!P[sku].soldout;
const imgSrc=(sku,small)=>small?P[sku].imgSm:P[sku].imgUrl;
const tierPct=n=>{let p=0;D.tiers.forEach(([t,pc])=>{if(n>=t)p=pc});return p};
const perUnit=sku=>{const p=P[sku];return `${eur(p.price/p.units)} per ${p.unit}`};
const thumb=(sku,cls='c-thumb')=>`<span class="${cls} panel" data-fam="${P[sku].fam}"><img class="prod" src="${imgSrc(sku,true)}" alt="" loading="lazy" decoding="async"></span>`;

/* ---------- toast ---------- */
let toastT;
function toast(msg){const t=$('#toast');if(!t)return;t.textContent=msg;t.classList.add('on');clearTimeout(toastT);toastT=setTimeout(()=>t.classList.remove('on'),2800)}

/* ---------- winkelwagen ---------- */
function setShopCart(c){
  shopCart=c;cart={};
  c.items.forEach(i=>{const k=skuById[i.variant_id];if(k)cart[k]=(cart[k]||0)+i.quantity});
}
function cartLines(){return shopCart.items.map(i=>{const sku=skuById[i.variant_id]||null;return {id:i.variant_id,sku,q:i.quantity,item:i,p:sku?P[sku]:null}})}
function cartTotals(){
  const L=cartLines();let trays=0;
  L.forEach(l=>{if(l.sku)trays+=l.q});
  const sub=shopCart.original_total_price/100,disc=shopCart.total_discount/100,total=shopCart.total_price/100;
  const pct=sub>0?Math.round(disc/sub*100):0;
  return {L,sub,trays,count:shopCart.item_count,pct,disc,total};
}
let queue=Promise.resolve();
function cartRequest(updates){
  queue=queue.then(()=>fetch(D.routes.update,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates})}).then(r=>{if(!r.ok)throw new Error('cart');return r.json()})).then(c=>{setShopCart(c);refreshCart()}).catch(()=>{toast('Er ging iets mis met de winkelmand. Probeer het opnieuw.');return refreshFromServer()});
  return queue;
}
function refreshFromServer(){return fetch(D.routes.cartJson,{headers:{Accept:'application/json'}}).then(r=>r.json()).then(c=>{setShopCart(c);refreshCart()}).catch(()=>{})}
function refreshCart(){renderCart();updatePdpShip();updateBundle();applyStock()}
function shipHTML(total,label){
  const left=Math.max(0,D.freeShip-total),w=Math.min(100,total/D.freeShip*100);
  return `<div class="bar"><i style="width:${w}%"></i></div><p class="${left===0?'ok':''}">${left>0?`${label||'Nog'} ${eur(left)} tot gratis verzending`:'Je bestelling wordt gratis bezorgd'}</p>`;
}
function renderCart(){
  const t=cartTotals(),badge=$('#cartCount');
  if(badge){badge.textContent=t.count;badge.classList.toggle('has',t.count>0)}
  const body=$('#drawerBody'),foot=$('#drawerFoot');
  if(!body)return;
  if(!t.count){
    body.innerHTML=`<div class="empty"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 8h14l-1 12H6L5 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg><p>Je winkelmand is nog leeg. Begin met een tray Classic.</p><a class="btn btn-primary" href="/collections/all">Bekijk alle Kinnie</a></div>`;
    foot.innerHTML='';foot.hidden=true;return;
  }
  foot.hidden=false;
  const next=t.trays<D.tiers[0][0]?D.tiers[0][0]:t.trays<D.tiers[1][0]?D.tiers[1][0]:0;
  const nudge=next?`<div class="nudge">Voeg nog ${next-t.trays} ${next-t.trays===1?'tray':'trays'} toe voor ${tierPct(next)}% bundelkorting. <button data-act="open-bundle">Bundel samenstellen</button></div>`:'';
  const lineHTML=l=>{
    const name=l.p?l.p.name:l.item.product_title;
    const th=l.sku?thumb(l.sku):`<span class="c-thumb panel">${l.item.image?`<img class="prod" src="${l.item.image}" alt="" loading="lazy">`:''}</span>`;
    return `<div class="c-line">${th}<div class="c-info"><b>${name}</b><span>${eur(l.item.original_price/100)} per stuk</span></div><div class="stepper sm"><button data-act="c-dec" data-id="${l.id}" aria-label="Minder ${name}">−</button><output>${l.q}</output><button data-act="c-inc" data-id="${l.id}" aria-label="Meer ${name}">+</button></div></div>`;
  };
  body.innerHTML=`<div class="ship">${shipHTML(t.total)}</div>`+t.L.map(lineHTML).join('')+nudge;
  foot.innerHTML=`<div class="sum-lines"><div class="sum-line"><span>Subtotaal</span><span>${eur(t.sub)}</span></div>${t.pct?`<div class="sum-line save"><span>Bundelkorting (${t.pct}%)</span><span>−${eur(t.disc)}</span></div>`:''}<div class="sum-line"><span>Verzending</span><span>${t.total>=D.freeShip?'Gratis':'Berekend bij afrekenen'}</span></div><div class="sum-line total"><span>Totaal</span><span>${eur(t.total)}</span></div></div><button class="btn btn-primary btn-block" data-act="checkout">Afrekenen</button><p class="fine">Veilig betalen met iDEAL, Wero, Bancontact, PayPal, Klarna en meer. <a href="${LEG.ship}">Verzending &amp; levering</a> · <a href="${LEG.ret}">Retourneren</a></p>`;
}
function bump(){
  const b=$('#cartCount'),c=$('#cartBtn');
  if(b){b.classList.remove('bump');void b.offsetWidth;b.classList.add('bump')}
  if(c){c.classList.remove('wiggle');void c.offsetWidth;c.classList.add('wiggle')}
}
function fly(from,sku){
  const target=$('#cartBtn');
  if(reduce||!from||!target)return Promise.resolve();
  const a=from.getBoundingClientRect(),b=target.getBoundingClientRect();
  const d=document.createElement('div');d.className='fly';const s=54;
  d.style.cssText=`width:${s}px;height:${s}px;left:${a.left+a.width/2-s/2}px;top:${a.top+a.height/2-s/2}px`;
  d.innerHTML=`<img src="${imgSrc(sku,true)}" alt="">`;document.body.appendChild(d);
  const dx=b.left+b.width/2-(a.left+a.width/2),dy=b.top+b.height/2-(a.top+a.height/2);
  const an=d.animate([{transform:'translate(0,0) scale(1)',opacity:1},{transform:`translate(${dx*.4}px,${dy*.4-80}px) scale(1.2)`,opacity:1,offset:.45},{transform:`translate(${dx}px,${dy}px) scale(.3)`,opacity:.4}],{duration:750,easing:'cubic-bezier(.5,0,.3,1)'});
  return new Promise(r=>{an.onfinish=()=>{d.remove();r()}});
}
function addToCart(sku,qty,src,opts={}){
  if(isSold(sku))return;
  cartRequest({[P[sku].id]:(cart[sku]||0)+qty}).then(()=>bump());
  fly(src,sku).then(()=>{if(opts.open)openCart()});
  if(reduce&&opts.open)openCart();
  if(src&&src.classList&&src.classList.contains('btn')&&!src.dataset.keep){
    const old=src.innerHTML;src.classList.add('done');src.textContent='Toegevoegd';
    setTimeout(()=>{src.classList.remove('done');src.innerHTML=old},1500);
  }
  toast(`${qty>1?qty+' × ':''}${P[sku].name} toegevoegd`);
}

/* ---------- overlays ---------- */
let lastFocus=null;
function openCart(){closeAll(true);lastFocus=document.activeElement;$('#drawer').classList.add('open');$('#drawer').setAttribute('aria-hidden','false');$('#scrim').classList.add('on');setTimeout(()=>$('#drawerClose').focus(),60)}
function openMenu(){lastFocus=document.activeElement;$('#mmenu').classList.add('open');$('#mmenu').setAttribute('aria-hidden','false');$('#menuBtn').setAttribute('aria-expanded','true')}
function openSearch(){lastFocus=document.activeElement;const s=$('#search');s.classList.add('open');s.setAttribute('aria-hidden','false');renderSearch('');setTimeout(()=>$('#searchInput').focus(),60)}
function closeAll(silent){
  const sheetWasOpen=$('#bsheet').classList.contains('open');
  const open=$('#bsheet').classList.contains('open')||$('#drawer').classList.contains('open')||$('#mmenu').classList.contains('open')||$('#search').classList.contains('open');
  $('#bsheet').classList.remove('open');$('#bsheet').setAttribute('aria-hidden','true');
  $('#drawer').classList.remove('open');$('#drawer').setAttribute('aria-hidden','true');
  $('#mmenu').classList.remove('open');$('#mmenu').setAttribute('aria-hidden','true');
  $('#search').classList.remove('open');$('#search').setAttribute('aria-hidden','true');
  $('#scrim').classList.remove('on');$('#menuBtn').setAttribute('aria-expanded','false');
  if(sheetWasOpen&&pdpMode==='bundle'&&!silent){pdpMode='single';$$('.mode-opt').forEach(b=>b.setAttribute('aria-checked',b.dataset.m==='single'));const bx=$('#modeBox');if(bx)bx.dataset.mode='single';const bar=$('#pdpBar .act-buy');if(bar)bar.textContent='In winkelmand'}
  if(open&&!silent&&lastFocus&&lastFocus.focus)lastFocus.focus();
}
function renderSearch(q){
  q=q.trim().toLowerCase();const out=$('#searchResults');
  const items=Object.entries(P).filter(([k,p])=>!q||(p.name+' '+p.famName+' '+p.fmt).toLowerCase().includes(q));
  const more=q?`<a class="sr-item" href="${D.routes.search}?q=${encodeURIComponent(q)}"><span><b>Alle resultaten voor “${q.replace(/[<>&"]/g,'')}”</b></span></a>`:'';
  out.innerHTML=more+(items.length?items.map(([k,p])=>`<a class="sr-item" href="${p.url}">${thumb(k)}<span><b>${p.name}</b><span class="muted">${isSold(k)?'Uitverkocht':perUnit(k)}</span></span><span class="price">${eur(p.price)}</span></a>`).join(''):`<p class="sr-hint">Geen resultaten voor “${q.replace(/[<>&"]/g,'')}”. Probeer Classic, Zero, Zest, Spritz of Rumba.</p>`);
}

/* ---------- decoratie: golven, boot, belletjes ---------- */
function waveD(period,amp,base,phase){let d='M0,200 L0,'+(base+amp*Math.sin(phase)).toFixed(1);for(let x=20;x<=2880;x+=20)d+=' L'+x+','+(base+amp*Math.sin(2*Math.PI*x/period+phase)).toFixed(1);return d+' L2880,200 Z'}
const waveSVG=(fill,period,amp,base,phase,speed,rev)=>`<svg class="wave${rev?' rev':''}" style="--sp:${speed}s" viewBox="0 0 2880 200" preserveAspectRatio="none" aria-hidden="true"><path style="fill:${fill}" d="${waveD(period,amp,base,phase)}"/></svg>`;
const BOAT=`<div class="boat-bob"><svg viewBox="0 0 220 110" aria-hidden="true"><defs><clipPath id="hull"><path d="M8,38 Q110,70 212,12 L206,36 Q190,76 140,86 Q70,94 22,60 Z"/></clipPath></defs><path d="M150,40 L150,10" stroke="#8E5A2E" stroke-width="3" stroke-linecap="round"/><circle cx="150" cy="8" r="5" fill="#FFB21E"/><path d="M8,38 Q110,70 212,12 L206,36 Q190,76 140,86 Q70,94 22,60 Z" fill="#FFC928"/><g clip-path="url(#hull)"><path d="M0,50 Q110,86 214,24" stroke="#1C7FD0" stroke-width="10" fill="none"/><path d="M0,64 Q110,98 206,42" stroke="#D9261C" stroke-width="8" fill="none"/></g><path d="M8,38 Q110,70 212,12" stroke="#fff" stroke-width="3" fill="none" stroke-linecap="round"/><circle cx="188" cy="36" r="8" fill="#fff"/><circle cx="190" cy="36" r="4" fill="#3A1517"/><path d="M178,30 Q188,24 198,28" stroke="#3A1517" stroke-width="2" fill="none" stroke-linecap="round"/></svg></div>`;
$$('[data-waves]').forEach((el,n)=>{
  const c=el.dataset.waves.split('|');
  el.innerHTML=waveSVG(c[0],480,10,70,0,34,true)+waveSVG(c[1]||c[0],720,13,108,1.2+n,24,false)+(c[2]?waveSVG(c[2],360,9,150,2.4+n,17,true):'');
});
$$('[data-boat]').forEach(el=>{el.innerHTML=BOAT;el.style.animationDelay=(el.dataset.boat||'0')+'s'});
$$('[data-bubbles]').forEach(el=>{let s='';for(let i=0;i<+el.dataset.bubbles;i++)s+=`<i style="--x:${rnd(8,92).toFixed(0)}%;--s:${rnd(6,15).toFixed(0)}px;--d:${rnd(5,9).toFixed(1)}s;--dl:${(-rnd(0,8)).toFixed(1)}s"></i>`;el.innerHTML=s});

/* letter-voor-letter kop */
$$('[data-wave]').forEach(h=>{
  const t=h.textContent.trim();h.setAttribute('aria-label',t);let c=0;
  h.innerHTML=t.split(' ').map(w=>`<span class="w" aria-hidden="true">${[...w].map(ch=>`<span class="ch" style="--c:${c++}">${ch}</span>`).join('')}</span>`).join(' ');
});

/* ---------- productkaarten: stock + formaat ---------- */
function applyStock(){
  $$('[data-sku]').forEach(el=>{
    if(!el.classList.contains('pcard')&&!el.classList.contains('flav-card')&&el.id!=='pdp')return;
    if(!P[el.dataset.sku])return;
    const sold=isSold(el.dataset.sku);
    el.dataset.soldout=sold?'1':'0';
    $$('.tag.sold',el).forEach(t=>t.hidden=!sold);
  });
  if(typeof renderHeroQuick==='function')renderHeroQuick();
  if(typeof renderBuilders==='function')renderBuilders();
  if(typeof applyShopFilters==='function')applyShopFilters();
  renderCart();
}
function setCardSku(card,sku){
  const p=P[sku];card.dataset.sku=sku;
  const set=(f,fn)=>$$(`[data-f="${f}"]`,card).forEach(fn);
  set('img',e=>{e.classList.remove('swapin');e.style.opacity=0;setTimeout(()=>{e.src=imgSrc(sku,true);e.style.opacity=1},160)});
  set('price',e=>e.textContent=eur(p.price));
  set('per',e=>e.textContent=perUnit(sku));
  $$('[data-add]',card).forEach(b=>b.dataset.add=sku);
  $$('.seg button',card).forEach(b=>b.setAttribute('aria-pressed',b.dataset.fmt===p.fmt));
  applyStock();
}

/* ---------- hero (home) ---------- */
let heroFam='classic';
function renderHeroQuick(){
  const q=$('#quick');if(!q)return;
  const sku=heroFam+'-blik',p=P[sku];if(!p){q.innerHTML='';return}const sold=isSold(sku);
  q.innerHTML=`<div><b>${p.famName}</b><small>Blik 0,33L ×24 · ${sold?'Uitverkocht':eur(p.price)}</small></div>`+(sold?`<a class="btn btn-dark" href="${p.url}">Meld me aan</a>`:`<button class="btn btn-primary" data-add="${sku}">In winkelmand</button>`);
}
function setHero(k,first){
  heroFam=k;const hero=$('#hero');if(!hero)return;hero.dataset.flavor=k;
  $$('.fswitch button').forEach(b=>b.setAttribute('aria-pressed',b.dataset.k===k));
  $('#fline').textContent=D.families[k].tagline;
  const holder=$('#heroPack'),swap=()=>{const i=$('img',holder);i.src=D.assets[k+'-can'];i.alt=`${D.families[k].name}, blik`;holder.classList.remove('out')};
  if(first||reduce)swap();else{holder.classList.add('out');setTimeout(swap,280)}
  renderHeroQuick();
}

/* ---------- shop: filters ---------- */
let shopFam='all';
function applyShopFilters(){
  const grid=$('#pgrid');if(!grid||!$('#fFmt'))return;
  const fmt=$('#fFmt').value,onlyStock=$('#fStock').checked,sort=$('#fSort').value;
  const cards=$$('.pcard',grid);let n=0;
  cards.forEach(c=>{
    const famOk=shopFam==='all'||(shopFam==='apperitivo'?['spritz','rumba'].includes(c.dataset.fam):c.dataset.fam===shopFam);
    const fmtOk=fmt==='all'||c.dataset.fmt===fmt;
    const stockOk=!onlyStock||c.dataset.soldout!=='1';
    const show=famOk&&fmtOk&&stockOk;c.hidden=!show;if(show)n++;
  });
  const key={rec:c=>+c.dataset.order,asc:c=>+c.dataset.price*1000+ +c.dataset.order,desc:c=>-c.dataset.price*1000+ +c.dataset.order}[sort];
  cards.sort((a,b)=>key(a)-key(b)).forEach(c=>grid.appendChild(c));
  $('#count').textContent=`${n} ${n===1?'product':'producten'}`;
  $('#noResults').hidden=n>0;
}

/* ---------- productpagina ---------- */
let curSku=null,qty=1;
function setPdpSku(sku,first){
  const pdp=$('#pdp');if(!pdp)return;curSku=sku;const p=P[sku];pdp.dataset.sku=sku;
  $$('.fmt-seg button').forEach(b=>b.setAttribute('aria-pressed',b.dataset.sku===sku));
  $$('[data-f="price"]').forEach(e=>e.textContent=eur(p.price));
  $$('[data-f="per"]').forEach(e=>e.textContent=perUnit(sku));
  $$('[data-f="sub"]').forEach(e=>e.textContent=p.name.replace(/^Kinnie \w+, /,''));
  $$('[data-long]').forEach(e=>e.hidden=e.dataset.long!==p.fmt);
  $$('[data-f="barname"]').forEach(e=>e.textContent=p.name);
  const cut=$$('.g-thumb.cut').find(t=>t.dataset.sku===sku);
  if(cut&&!first)showGallery(cut);
  $$('[data-add]',pdp).forEach(b=>b.dataset.add=sku);
  const bar=$('#pdpBar');if(bar)$$('[data-add]',bar).forEach(b=>b.dataset.add=sku);
  applyStock();updatePdpShip();
}
function showGallery(btn){
  $$('.g-thumb').forEach(t=>t.setAttribute('aria-pressed',t===btn));
  const main=$('#gMain'),stage=$('#gStage img');
  if(btn.dataset.photo){$('#gPhoto').src=btn.dataset.photo;$('#gPhoto').alt=btn.dataset.alt||'';$('#gPhoto').style.objectPosition=btn.dataset.pos||'50% 50%';main.classList.add('show-photo')}
  else{main.classList.remove('show-photo');stage.style.opacity=0;setTimeout(()=>{stage.src=imgSrc(btn.dataset.sku);stage.style.opacity=1},160)}
}
function updatePdpShip(){
  const el=$('#pdpShip');if(!el||!curSku)return;
  const t=cartTotals();el.innerHTML=shipHTML(t.total+P[curSku].price*qty*(1-0),'Met deze selectie nog');
}
function setQty(n){qty=Math.max(1,Math.min(20,n));$$('[data-f="qty"]').forEach(e=>e.textContent=qty);$$('[data-act="q-dec"]').forEach(b=>b.disabled=qty<=1);updatePdpShip()}

/* ---------- bundel & bespaar ---------- */
/* Shopify-vertaling: de bundelkorting is een automatische staffelkorting op de hele winkelwagen (collectie 'bundel-en-bespaar').
   De bouwer hieronder is alleen een UI die varianten in de winkelwagen zet; alle prijzen en staffels komen uit data.js. */
const B=D.bundle,MAXQ=9;
let bundle=store.get('kb_bundle',{});
const saveBundle=()=>store.set('kb_bundle',bundle);
const fmtLabel=sku=>{const p=P[sku];return p.fmt==='blik'?'Blik 0,33L ×24':p.fmt==='fles'?'Fles 0,5L ×12':'Glazen fles 25cl ×24'};
function cleanBundle(){Object.keys(bundle).forEach(s=>{if(!P[s]||isSold(s)||!(bundle[s]>0))delete bundle[s]})}
function bTotals(){
  cleanBundle();
  let n=0,sub=0;Object.entries(bundle).forEach(([s,q])=>{n+=q;sub+=P[s].price*q});
  const c=cartTotals(),all=n+c.trays,pct=tierPct(all);
  const disc=(sub+c.sub)*pct/100-c.disc;
  const nextT=D.tiers.map(t=>t[0]).find(t=>t>all);
  return {n,sub,pct,disc,total:sub-disc,combined:(sub+c.sub)*(1-pct/100),all,inCart:c.trays,nextT};
}
function tierBar(t){
  const max=D.tiers[D.tiers.length-1][0],w=Math.min(100,t.all/max*100);
  const marks=D.tiers.map(([n,pc])=>`<span class="tm${t.all>=n?' on':''}" style="left:${n/max*100}%"><b>${pc}%</b><small>${n}${n===max?'+':''} trays</small></span>`).join('');
  const left=t.nextT?t.nextT-t.all:0;
  const T1=D.tiers[0],T2=D.tiers[1];
  let msg;
  if(t.all===0)msg=`Kies je trays: ${T1[0]} voor ${T1[1]}% korting, ${T2[0]} voor ${T2[1]}% korting.`;
  else if(t.all<T1[0])msg=`${t.all} van ${T1[0]} geselecteerd. Voeg nog ${T1[0]-t.all} toe voor ${T1[1]}% korting.`;
  else if(t.all<T2[0])msg=`${t.all} geselecteerd. ${T1[1]}% bundelkorting actief ✓ Voeg nog ${T2[0]-t.all} toe en ontvang ${T2[1]}% korting.`;
  else msg=`${t.all} geselecteerd. ${T2[1]}% bundelkorting actief ✓`;
  return `<div class="tbar"><div class="track"><i style="width:${w}%"></i></div>${marks}</div><p class="tmsg">${msg}${t.inCart?` <small>(inclusief ${t.inCart} in je winkelmand)</small>`:''}</p>`;
}
function bItem(sku){
  const p=P[sku],sold=isSold(sku),q=bundle[sku]||0;
  const ctrl=sold?`<span class="tag sold">Uitverkocht</span>`:`<div class="stepper sm" role="group" aria-label="Aantal ${p.name}"><button data-act="b-dec" data-sku="${sku}" aria-label="Minder ${p.name}">−</button><output aria-live="polite">${q}</output><button data-act="b-inc" data-sku="${sku}" aria-label="Meer ${p.name}">+</button></div>`;
  return `<div class="bx${q?' has':''}${sold?' is-sold':''}" data-bsku="${sku}"><span class="panel" data-fam="${p.fam}">${p.apperitivo?'<span class="tag age">18+</span>':''}<img class="prod" src="${imgSrc(sku,true)}" alt="" loading="lazy" decoding="async"></span><div class="bx-info"><b>${p.famName}</b><small>${fmtLabel(sku)}</small><span class="bx-price">${eur(p.price)}${p.was?` <s>${eur(p.was)}</s>`:''}</span></div>${ctrl}</div>`;
}
function renderBuilders(){
  $$('[data-builder]').forEach(el=>{el.innerHTML=B.groups.map(([title,skus])=>[title,skus.filter(k=>P[k])]).filter(g=>g[1].length).map(([title,skus])=>`<section class="bgroup"><h3>${title}</h3><div class="bgrid">${skus.map(bItem).join('')}</div></section>`).join('')});
  updateBundle();
}
function bSumHTML(t,mode){
  const label=t.n?`Bundel in winkelmand <span>${eur(t.total)}</span>`:'Kies je trays';
  const ship=shipHTML(t.combined,'Nog');
  if(mode==='foot')return `<div class="bf-row"><div><b>${t.n} ${t.n===1?'tray':'trays'}</b>${t.disc>0.005?`<span class="save-pill">Je bespaart ${eur(t.disc)}</span>`:''}</div><div class="bf-ship">${t.combined>=D.freeShip?'Gratis verzending':`Nog ${eur(D.freeShip-t.combined)} tot gratis verzending`}</div></div><button class="btn btn-primary btn-block" data-act="b-add" ${t.n?'':'disabled'}>${label}</button>`;
  const crate=t.n?Object.entries(bundle).map(([s,q])=>Array.from({length:q},()=>`<img src="${imgSrc(s,true)}" alt="">`).join('')).join(''):'<span class="empty-t">Je bundel is nog leeg.</span>';
  return `<h2>Jouw bundel</h2><div class="crate" aria-label="Overzicht van je bundel">${crate}</div>${t.disc>0.005?`<span class="save-pill">Je bespaart ${eur(t.disc)}</span>`:''}<div class="ship">${ship}</div><div class="sum-lines"><div class="sum-line"><span>Originele prijs (${t.n} ${t.n===1?'tray':'trays'})</span><span>${t.disc>0.005?`<s>${eur(t.sub)}</s>`:eur(t.sub)}</span></div>${t.pct&&t.n?`<div class="sum-line save"><span>Bundelkorting (${t.pct}%)</span><span>−${eur(t.disc)}</span></div>`:''}<div class="sum-line total"><span>Nieuwe bundelprijs</span><span class="bt">${eur(t.total)}</span></div></div><button class="btn btn-primary btn-block" data-act="b-add" ${t.n?'':'disabled'}>${label}</button>`;
}
let prevB=null;
function updateBundle(){
  cleanBundle();
  $$('.bx[data-bsku]').forEach(el=>{
    const s=el.dataset.bsku,q=bundle[s]||0,o=$('output',el);
    if(o&&o.textContent!==String(q)){o.textContent=q;if(!reduce){o.classList.remove('pop');void o.offsetWidth;o.classList.add('pop')}}
    el.classList.toggle('has',q>0);
    const d=$('[data-act="b-dec"]',el),i=$('[data-act="b-inc"]',el);if(d)d.disabled=q===0;if(i)i.disabled=q>=MAXQ;
  });
  const t=bTotals();
  $$('[data-tier]').forEach(e=>e.innerHTML=tierBar(t));
  $$('[data-bsum]').forEach(e=>e.innerHTML=bSumHTML(t,e.dataset.bsum));
  const bar=$('#bundleBar');
  if(bar){$('[data-f="btotal"]',bar).textContent=eur(t.total);$('[data-f="bcount"]',bar).textContent=`${t.n} ${t.n===1?'tray':'trays'}${t.pct&&t.n?` · ${t.pct}% korting`:''}`;$('button',bar).disabled=t.n===0}
  $$('.preset[data-p]').forEach(b=>{const pr=B.presets.find(p=>p.key===b.dataset.p);if(!pr)return;const a=Object.keys(pr.items),c=Object.keys(bundle);b.setAttribute('aria-pressed',a.length===c.length&&a.every(k=>bundle[k]===pr.items[k]))});
  if(prevB!==null&&prevB!==t.total&&!reduce)$$('.bt,.bf-row b').forEach(e=>{e.classList.remove('pulse');void e.offsetWidth;e.classList.add('pulse')});
  prevB=t.total;
}
function openBundle(sku){
  if($('#builder')){closeAll(true);const b=$('#builder');if(b)b.scrollIntoView({behavior:reduce?'auto':'smooth',block:'start'});return}
  closeAll(true);lastFocus=document.activeElement;cleanBundle();
  if(sku&&!isSold(sku)&&!bundle[sku]){bundle[sku]=1;saveBundle()}
  const s=$('#bsheet');s.classList.add('open');s.setAttribute('aria-hidden','false');$('#scrim').classList.add('on');
  updateBundle();setTimeout(()=>$('#bsClose').focus(),60);
}
function renderMini(key){
  const el=$('#miniCalc');if(!el)return;
  const pr=B.presets.find(p=>p.key===key)||B.presets[0];let n=0,sub=0;const names=[];
  Object.entries(pr.items).forEach(([s,q])=>{if(!P[s])return;n+=q;sub+=P[s].price*q;names.push(`${q} × ${P[s].famName.replace('Kinnie ','')} ${P[s].fmt==='blik'?'blik':P[s].fmt==='fles'?'fles':''}`.trim())});
  const pct=tierPct(n),disc=sub*pct/100;
  $$('.preset[data-m]').forEach(b=>b.setAttribute('aria-pressed',b.dataset.m===pr.key));
  el.innerHTML=`<div class="sum-line"><span>${names.join(', ')}</span><span>${eur(sub)}</span></div>${pct?`<div class="sum-line save"><span>Bundelkorting (${pct}%)</span><span>−${eur(disc)}</span></div>`:''}<div class="sum-line total"><span>Totaal</span><span>${eur(sub-disc)}</span></div>`;
}
/* productpagina: los bestellen of bundelen */
let pdpMode='single';
function setMode(m){
  pdpMode=m;$$('.mode-opt').forEach(b=>b.setAttribute('aria-checked',b.dataset.m===m));
  const bx=$('#modeBox');if(bx)bx.dataset.mode=m;
  const bar=$('#pdpBar .act-buy');if(bar)bar.textContent=m==='bundle'?'Stel je bundel samen':'In winkelmand';
  if(m==='bundle')openBundle(curSku);
}

/* ---------- klik-acties ---------- */
document.addEventListener('click',e=>{
  const addBtn=e.target.closest('[data-add]');
  if(addBtn){
    if(pdpMode==='bundle'&&addBtn.closest('#pdp,#pdpBar')){openBundle(curSku);return}
    const sku=addBtn.dataset.add,onPdp=!!addBtn.closest('#pdp,#pdpBar');
    const img=addBtn.closest('.pcard,.flav-card,.ap-card,.quick,#pdp,#pdpBar');
    const from=(img&&$('img.prod,#gStage img',img))||addBtn;
    addToCart(sku,onPdp?qty:1,from.getBoundingClientRect().width?from:addBtn,{open:onPdp});
    if(addBtn.closest('#pdpBar'))addBtn.dataset.keep='1';
    return;
  }
  const el=e.target.closest('[data-act]');if(!el)return;
  const a=el.dataset.act;
  if(a==='open-cart')openCart();
  else if(a==='open-menu')openMenu();
  else if(a==='open-search')openSearch();
  else if(a==='close-all')closeAll();
  else if(a==='c-inc'||a==='c-dec'){const id=+el.dataset.id,it=shopCart.items.find(i=>i.variant_id===id);if(!it)return;cartRequest({[id]:Math.max(0,it.quantity+(a==='c-inc'?1:-1))});if(a==='c-inc')bump()}
  else if(a==='checkout'){location.href='/checkout'}
  else if(a==='hero')setHero(el.dataset.k);
  else if(a==='fmt'){const card=el.closest('[data-fam]');const k=card.dataset.fam+'-'+el.dataset.fmt;if(P[k])setCardSku(card,k)}
  else if(a==='filter'){shopFam=el.dataset.v;$$('[data-act="filter"]').forEach(b=>b.setAttribute('aria-pressed',b===el));applyShopFilters()}
  else if(a==='pdp-fmt')setPdpSku(el.dataset.sku);
  else if(a==='gthumb')showGallery(el);
  else if(a==='q-inc')setQty(qty+1);
  else if(a==='q-dec')setQty(qty-1);
  else if(a==='b-inc'){const k=el.dataset.sku;bundle[k]=Math.min(MAXQ,(bundle[k]||0)+1);saveBundle();updateBundle();if(!reduce){const bx=el.closest('.bx');bx&&bx.classList.remove('hit');bx&&void bx.offsetWidth;bx&&bx.classList.add('hit')}}
  else if(a==='b-dec'){const k=el.dataset.sku;bundle[k]=Math.max(0,(bundle[k]||0)-1);if(!bundle[k])delete bundle[k];saveBundle();updateBundle()}
  else if(a==='preset'){const pr=B.presets.find(p=>p.key===el.dataset.p);bundle={};Object.entries(pr.items).forEach(([k,q])=>{if(!isSold(k))bundle[k]=q});saveBundle();updateBundle()}
  else if(a==='mini')renderMini(el.dataset.m);
  else if(a==='open-bundle')openBundle(el.dataset.from==='pdp'?curSku:undefined);
  else if(a==='mode')setMode(el.dataset.m);
  else if(a==='b-add'){
    const t=bTotals();if(!t.n)return;
    const first=Object.keys(bundle)[0],updates={};
    Object.entries(bundle).forEach(([k,q])=>{updates[P[k].id]=(cart[k]||0)+q});
    bundle={};saveBundle();
    cartRequest(updates).then(()=>bump());
    fly(el,first).then(()=>openCart());
    if(reduce)openCart();
    toast(`Bundel toegevoegd: ${t.n} ${t.n===1?'tray':'trays'}${t.disc>0.005?`, je bespaart ${eur(t.disc)}`:''}`);
  }
  else if(a==='chip'){$$('.chip[data-act="chip"]').forEach(b=>b.setAttribute('aria-pressed',b===el));$('#chipText').textContent=el.dataset.t}
  else if(a==='copy'){
    const txt=el.dataset.text;
    (navigator.clipboard?navigator.clipboard.writeText(txt):Promise.reject()).then(()=>toast('Gekopieerd')).catch(()=>{const c=$('code',el.parentNode);if(c){const r=document.createRange();r.selectNodeContents(c);const s=getSelection();s.removeAllRanges();s.addRange(r)}toast('Selecteer het adres en kopieer het')});
  }
});
document.addEventListener('keydown',e=>{if(e.key==='Escape')closeAll()});
document.addEventListener('change',e=>{
  if(['fFmt','fStock','fSort'].includes(e.target.id))applyShopFilters();
});
document.addEventListener('input',e=>{
  if(e.target.id==='searchInput')renderSearch(e.target.value);
  if(e.target.id==='faqSearch'){
    const q=e.target.value.trim().toLowerCase();let n=0;
    $$('#faqList details').forEach(d=>{const show=!q||d.textContent.toLowerCase().includes(q);d.hidden=!show;if(show)n++;if(q&&show)d.open=true});
    $$('.faq-group').forEach(g=>g.hidden=!$$('details',g).some(d=>!d.hidden));
    $('#faqNone').hidden=n>0;
  }
});

/* ---------- beweging: kantelen, parallax, onthullen ---------- */
document.addEventListener('pointermove',e=>{
  if(reduce||e.pointerType==='touch')return;
  const t=e.target.closest('[data-tilt]');if(!t)return;
  const r=t.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5,el=$('.tilt',t);
  if(el){el.style.setProperty('--ry',(x*20).toFixed(1)+'deg');el.style.setProperty('--rx',(-y*14).toFixed(1)+'deg')}
});
document.addEventListener('pointerout',e=>{
  const t=e.target.closest('[data-tilt]');if(!t||t.contains(e.relatedTarget))return;
  const el=$('.tilt',t);if(el){el.style.setProperty('--ry','0deg');el.style.setProperty('--rx','0deg')}
});
let io;
function observeReveal(){
  if(!('IntersectionObserver' in window)){$$('.reveal').forEach(n=>n.classList.add('in'));return}
  io=io||new IntersectionObserver(es=>es.forEach(en=>{if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target);setTimeout(()=>en.target.classList.add('settled'),1300)}}),{threshold:.12,rootMargin:'0px 0px -5% 0px'});
  $$('.reveal:not(.in)').forEach(n=>io.observe(n));
}
const header=$('#siteHeader'),pars=$$('[data-par]');
let ticking=false;
function onScroll(){
  const y=scrollY;
  if(header)header.classList.toggle('scrolled',y>10);
  if(!reduce){
    const vh=innerHeight;
    pars.forEach(n=>{
      const r=n.parentElement.getBoundingClientRect();
      if(r.bottom<-100||r.top>vh+100)return;
      const off=((r.top+r.height/2)-vh/2)*-parseFloat(n.dataset.par);
      n.style.transform=`translate3d(0,${off.toFixed(1)}px,0)${n.tagName==='IMG'?` scale(${n.dataset.scale||1.14})`:''}`;
    });
  }
  const bar=$('#pdpBar'),atc=$('#modeBox');
  if(bar&&atc){const r=atc.getBoundingClientRect();bar.classList.toggle('show',r.bottom<0||r.top>innerHeight)}
  const bb=$('#bundleBar'),sum=$('#bSum');
  if(bb&&sum){const r=sum.getBoundingClientRect();bb.classList.toggle('show',r.top>innerHeight||r.bottom<0)}
  ticking=false;
}
addEventListener('scroll',()=>{if(!ticking){ticking=true;requestAnimationFrame(onScroll)}},{passive:true});
const msgs=$$('.announce span');let mi=0;
if(msgs.length>1)setInterval(()=>{msgs[mi].classList.remove('on');mi=(mi+1)%msgs.length;msgs[mi].classList.add('on')},4500);

/* ---------- start ---------- */
if(page==='index'){setHero('classic',true);renderMini('fan')}
if(page==='product'){const pdp=$('#pdp');if(pdp&&P[pdp.dataset.sku]){setQty(1);setPdpSku(pdp.dataset.sku,true)}}
if(page==='page-faq'){const h=location.hash.replace('#','');if(h){const d=$('#'+h);if(d&&d.tagName==='DETAILS')d.open=true}}
applyStock();renderCart();observeReveal();onScroll();
refreshFromServer();
})();
